import { ItemTypes, uuid } from '../constants/constants';
import { pageHeight, pageWidth } from '../constants/gridConfig';
import { mutateAddBoxes, mutateRemoveBox } from './boxes';
import { mutateUpdateColumn, newColumn } from './columns';
import { mutateUpdateContainer, newContainer } from './containers';

export const mutateCreateMask = ({ draft, name, KeyPdfToImage = null }) => {
  const maskId = uuid();
  draft.masks = [
    ...draft.masks,
    {
      id: maskId,
      name,
      boxes: [],
      editableMask: true,
      hasNotPageNumber: true,
      KeyPdfToImage,
    },
  ];
};

export const mutateInjectMask = ({ draft, maskId, boxId }) => {
  const maskContent = draft.masks.find((m) => m.id === maskId);
  const box = draft.boxes.find((b) => b.id === boxId);
  const column = draft.columns.find((c) => c.id === box.columnId);
  const containerIndex = draft.containers.findIndex((c) =>
    c.columnsIds.includes(box.columnId)
  );
  const container = draft.containers[containerIndex];
  column.maskId = maskId;
  // TODO : check existence
  column.updateTimestamp = maskContent.updateTimestamp;
  // Le fond fait partie du masque : une fois injecté, c'est la colonne qui est
  // rendue (le masque n'est résolu que dans son propre éditeur), sans recopie la
  // page repartirait donc en transparent.
  if (maskContent.backgroundColor) {
    column.backgroundColor = maskContent.backgroundColor;
  }
  const boxesToAdd = maskContent.boxes.map((b) => {
    return {
      ...b,
      oldId: b.id,
      id: uuid(),
      columnId: column.id,
    };
  });
  boxesToAdd.forEach((b) => {
    if (b.type === ItemTypes.GROUP_BOXES) {
      const boxIds = boxesToAdd
        .filter((bAdd) => b.boxIds.includes(bAdd.oldId))
        .map(({ id }) => id);
      b.boxIds = boxIds;
    }
  });
  boxesToAdd.forEach((b) => {
    delete b.oldId;
  });
  mutateUpdateContainer(draft, {
    ...container,
    height: draft.landscape ? pageWidth : pageHeight,
    editable: maskContent?.editableMask ?? true,
  });
  mutateUpdateColumn(draft, column);
  // remove mask "template" box
  mutateRemoveBox(draft, boxId);
  mutateAddBoxes({ draft, newBoxes: boxesToAdd });

  // If the mask is a chapter separator, create a linked title1 box right after the mask container
  if (maskContent.chapterSeparation) {
    const maskTitle1Box = maskContent.boxes.find((b) => b.type === ItemTypes.TITLE);
    if (maskTitle1Box) {
      const linkedColumn = newColumn({ size: 1 });
      const linkedContainer = newContainer({ height: 'auto', columnsIds: [linkedColumn.id] });
      const linkedTitleBox = {
        ...maskTitle1Box,
        id: uuid(),
        columnId: linkedColumn.id,
        linkedToMaskId: maskId,
      };
      // Bidirectional link between the two containers
      const maskContainer = draft.containers[containerIndex];
      maskContainer.linkedContainerId = linkedContainer.id;
      linkedContainer.linkedContainerId = maskContainer.id;
      draft.columns.push(linkedColumn);
      draft.containers.splice(containerIndex + 1, 0, linkedContainer);
      mutateAddBoxes({ draft, newBoxes: [linkedTitleBox] });
    }
  }
};
